import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { ConfigService } from 'src/app/core/service/config.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor( private apiService: ApiService) { }

  GetMainAuctions(modal: any) {
    return this.apiService
      .get(`${environment.apiUrl}auction/bidder/rooms`, modal)
      .pipe(catchError(this.handleError));
  }


  getCategories() {
    return this.apiService
      .get(`${environment.apiUrl}auction/categories?perPage=20&sort=ASC`)
      .pipe(catchError(this.handleError));
  }


  handleError(error: any) {
    return throwError(error);
  }

}
